<template>
  <div class="wc2026-page">
    <div class="wc2026-inner">
      <ActLang />
      <Banner />
      <login />
      <intro />

      <Tabs
        v-model="state.activeModule"
        @showHistory="showHistory"
        @showTask="showTask"
      />

      <!-- 主内容 -->
      <main
        class="wc-main"
        v-if="state.actInfo.isActivityStart && !state.actInfo.isActivityEnd"
      >
        <MatchList
          v-if="state.activeModule === 'toCheer'"
          :isBetEnd="state.actInfo.isBetEnd"
          @showRule="state.showBetRuleDialog = true"
          @showRecord="requireLogin(showRecord)"
          @cheerSuccess="loadActivityInfo"
        />
        <RankContent v-if="state.activeModule === 'rank'" />
        <MilestoneContent v-if="state.activeModule === 'rank'" />
      </main>


    </div>

    <!-- ========= 弹窗区域 ========= -->

    <TaskDialog
      v-model="state.showTaskDialog"
      :taskList="state.taskList"
      @received="onTaskReceived"
      @refreshActivity="loadActivityInfo"
    />
    <CheerRecordDialog v-model="state.showRecordDialog" />
    <RuleDialog
      v-model="state.showBetRuleDialog"
      :title="$t('wc2026.bet.rule.title')"
      :content="$t('wc2026.bet.rule.content')"
    />
  </div>
  <AppFooter />
</template>

<script setup>
/* eslint-disable */
import { reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Tabs from "./components/tabs/index.vue";
import TaskDialog from "./components/TaskDialog/index.vue";
import MatchList from "./components/MatchList/index.vue";
import CheerRecordDialog from "./components/CheerRecordDialog/index.vue";
import RuleDialog from "./components/RuleDialog/index.vue";
import MilestoneContent from "./components/MilestoneContent/index.vue";
import RankContent from "./components/RankContent/index.vue";
import WcApi from "@/config/wcActApi";
import Banner from "./components/banner/index.vue";
import login from "./components/login/index.vue";
import intro from "./components/intro/index.vue";
import { useRoute, useRouter } from "vue-router";
 import ActLang from "./components/ActLang/index.vue";

import { useLog } from "@/composables/useActLog";
import AppFooter from "./components/AppFooter";
import ta from 'thinkingdata-browser'
const log = useLog();
const route = useRoute();
const router = useRouter();
const store = useStore();
const { t, locale } = useI18n();

document.body.classList.add("wc2026");

log.track("act_worldcup_page", {})
watch(
  () => locale.value,
  () => {
    document.body.style.fontFamily = "acc-" + locale.value;
    document.body.classList.add("acc-" + locale.value);
  },
  { immediate: true },
);

const initLogin = async () => {
  const tokenHash = route.query?.tokenHash;
  const uid = route.query?.uid;
  if (tokenHash && uid) {
    router.replace({
      query: {
        uid: undefined,
        tokenHash: undefined,
      },
    });
    await WcApi.gameTokenLogin({
      uid: uid,
      tokenHash: tokenHash,
    });
  }
};

initLogin();
const state = reactive({
  cpUserInfo: computed(() => store.state.actUserInfo),
  isLoggedIn: computed(() => !!store.state.actUserInfo?.token),
  balance: 0,
  activeModule: "rank",
  // 弹窗可见性
  showLoginDialog: false,
  showTaskDialog: false,
  showRecordDialog: false,
  showMilestoneDialog: false,
  showRankDialog: false,
  showBetRuleDialog: false,
  // 数据
  taskList: [],
  actInfo: {
    isActivityStart: true,
    isActivityEnd: false,
    isBetEnd: false,
    serverTime: 0,
    totalCheerCount: 0,
    winCheerCount: 0,
    rankRewardReady: false,
  },
});

const showHistory = () => {
  state.showRecordDialog = true;
};
const showTask = () => {
  state.showTaskDialog = true;
};
const requireLogin = (fn) => {
  if (!state.isLoggedIn) {
    state.showLoginDialog = true;
    return;
  }
  fn();
};

const showRecord = () => {
  state.showRecordDialog = true;
};

const onTaskReceived = (data) => {
  log.track("act_worldcup_task_complete", {
    v1: data.taskType,
  });
  loadActivityInfo();
};

const loadActivityInfo = async () => {
  try {
    store.dispatch("wcAct/fetchActivityInfo");
  } catch (e) {
    console.error(e);
  }
};

const initData = async () => {
  await loadActivityInfo();
};

watch(
  () => store.state.actUserInfo,
  (newVal) => {
    if (newVal && newVal.token) {
      ta.login(newVal.uid)
      initData();
    }
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<style lang="less" scoped>
.wc2026-page {
  min-height: 100vh;
  background-image: url("~@/assets/imgs/act/wc2026/bg_yellow.png");
  display: flex;
  background-size: auto;
  background-repeat: repeat;
  justify-content: center;
}

.wc2026-inner {
  width: 750px;
  max-width: 100%;
  position: relative;
  overflow-x: hidden;
}

.page-banner {
  position: relative;
  width: 100%;

  .banner-img-slot {
    width: 100%;
    padding-top: 45.33%;
    background: linear-gradient(180deg, #0c3a1e 0%, #1a4a2e 50%, #0a2a16 100%);
    position: relative;

    &::after {
      content: "[ Banner 切图预留区域 750×340 ]";
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.2);
      font-size: 24px;
      pointer-events: none;
    }
  }

  .banner-lang-bar {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
  }
}

.status-banner {
  margin: 0 24px 16px;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 24px;
  text-align: center;
  font-weight: bold;

  &.warn {
    background: rgba(255, 193, 7, 0.15);
    border: 1px solid #ffc107;
    color: #e65100;
  }

  &.ended {
    background: rgba(244, 67, 54, 0.1);
    border: 1px solid #f44336;
    color: #f44336;
  }
}

.rank-reward-banner {
  margin: 0 24px 16px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #fff9e6, #fff3cd);
  border: 2px solid #ffc107;
  border-radius: 8px;
  color: #e65100;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.85;
  }
}

.main-tabs {
  display: flex;
  gap: 0;
  margin: 0 0 0 0;
  border-bottom: 3px solid rgba(76, 175, 80, 0.3);
  overflow-x: auto;
  scrollbar-width: none;
  background: rgba(0, 0, 0, 0.2);

  &::-webkit-scrollbar {
    display: none;
  }

  .main-tab {
    flex: 1;
    min-width: 0;
    padding: 22px 16px;
    font-size: 26px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    border-bottom: 4px solid transparent;
    margin-bottom: -3px;
    transition: all 0.2s;
    white-space: nowrap;
    text-align: center;

    &.active {
      color: #4caf50;
      border-bottom-color: #4caf50;
      background: rgba(76, 175, 80, 0.08);
    }

    &:hover:not(.active) {
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.page-footer {
  margin-top: 40px;
  padding-bottom: 40px;

  .footer-slot {
    // 预留页脚社交媒体图标切图区域
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 24px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    &::before {
      content: "[ 页脚图标切图预留 ]";
      color: rgba(255, 255, 255, 0.2);
      font-size: 20px;
    }
  }

  .footer-contact {
    text-align: center;

    .footer-tip {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.3);
      line-height: 1.6;
      margin: 0;
      padding: 0 24px;
    }
  }
}

.wc-btn {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;

  &.primary {
  }

  &.secondary {
  }

  &.accent {
    background: #4caf50;
    color: #fff;
    &:hover {
      background: #43a047;
    }
  }

  &.small {
    padding: 5px 14px;
    font-size: 12px;
  }
}
</style>
<style lang="less">
@import "./style/font.css";

.no-scroll {
  overflow: hidden !important;
}

.wc2026-page {
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  * {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .section-top {
    width: 100%;
    height: 43px;
    background-image: url("~@/assets/imgs/act/wc2026/section-top.png");
  }
  color: #1b0926;
  font-size: 17px;

  .blue-bg {
    background-image: url("~@/assets/imgs/act/wc2026/bg-blue.png");
    background-size: auto;
    background-repeat: repeat;
    background-position: center;
  }
  .green-bg {
    background-image: url("~@/assets/imgs/act/wc2026/bg_green.png");
    background-size: auto;
    background-repeat: repeat;
    background-position: center;
  }
  .flex {
    display: flex;
  }
}
.btn {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.wc2026 .pc.global-toast {
  font-size: 24px !important;
  padding: 10px 20px !important;
  border-radius: 10px !important;
}

.acc-vi {
  .logout-btn-text {
    font-size: 14px !important;
  }
  .rewardHistory {
    font-size: 11px !important;
  }
  .send-code-btn {
    font-size: 13px !important;
  }
}
.acc-th {
  .logout-btn-text {
    font-size: 12px;
  }
  .send-code-btn {
    font-size: 14px !important;
  }
  .cheer-count-wrap .label{
    font-size: 12px !important;
    font-weight: normal !important;
  }
}

.acc-sg {
  .send-code-btn {
    font-size: 14px !important;
  }
}

.acc-id {
  .can-receive {
    font-size: 12px !important;
  }
}
.acc-id {
  .toCheer {
    font-size: 14px !important;
  }
  .cheer-count-wrap .label{
    font-size: 14px !important;
  }
}
</style>
